import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_ESTUDIANTES = 'ALL_ESTUDIANTES';
export const ACTIVO_ESTUDIANTES = 'ACTIVO_ESTUDIANTES';
export const LOADING_ALL_ESTUDIANTES = 'LOADING_ALL_ESTUDIANTES';
export const PARAMS_ESTUDIANTES = 'PARAMS_ESTUDIANTES';
export const NOTAS_EVALUATIVAS_ESTUDIANTE = 'NOTAS_EVALUATIVAS_ESTUDIANTE';
export const ASISTENCIAS_DIARIAS_ESTUDIANTE = 'ASISTENCIAS_DIARIAS_ESTUDIANTE';
export const PARAMS_ESTUDIANTES_DOCENTE = 'PARAMS_ESTUDIANTES_DOCENTE';
export const ALL_ESTUDIANTES_DOCENTE = 'ALL_ESTUDIANTES_DOCENTE';
export const ALL_ESTUDIANTES_NOTAS = 'ALL_ESTUDIANTES_NOTAS';
export const SELECTS_ESTUDIANTES = 'SELECTS_ESTUDIANTES';

const initialState = {
  all: [],
  params: {
    idEntidad: null,
    idPeriodoAcademico: null,
    idSeccion: null,
    page: 1,
    limit: 60,
  },
  notasEvaluativas: [],
  actividadesExtras: [],
  asistenciasDiarias: [],
  allEstudiantesNotas: [],
  allEstudiantesAsistencias: [],
  activo: null,
  loadingAll: false,
  allEstudiantesDocente: [],
  paramsEstudiantesDocente: {
    idEntidad: null,
    idPeriodoAcademico: null,
    idSeccion: null,
    idMateria: null,
  },
  pagination: {
    currentPage: 1,
    itemCount: 1,
    itemsPerPage: 60,
    totalItems: 1,
    totalPages: 1,
  },
  selects: [],
};

export const estudiantesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_ESTUDIANTES:
      action.payload.data.sort(
        (a, b) => a.usuario.perfil.dni - b.usuario.perfil.dni,
      );
      return {
        ...state,
        all: action.payload.data,
        pagination: action.payload.meta,
      };
    case ALL_ESTUDIANTES_DOCENTE:
      return {
        ...state,
        allEstudiantesDocente: action.payload,
      };
    case ALL_ESTUDIANTES_NOTAS:
      return {
        ...state,
        allEstudiantesNotas: action.payload,
      };
    case ACTIVO_ESTUDIANTES:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_ALL_ESTUDIANTES:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_ESTUDIANTES:
      return {
        ...state,
        params: action.payload,
      };
    case PARAMS_ESTUDIANTES_DOCENTE:
      return {
        ...state,
        paramsEstudiantesDocente: action.payload,
      };
    case NOTAS_EVALUATIVAS_ESTUDIANTE:
      return {
        ...state,
        notasEvaluativas: action.payload.notasEvaluativas,
        actividadesExtras: action.payload.actividadesExtras,
      };
    case ASISTENCIAS_DIARIAS_ESTUDIANTE:
      return {
        ...state,
        asistenciasDiarias: action.payload,
      };
    case SELECTS_ESTUDIANTES:
      return {
        ...state,
        selects: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
